import {Component, ContentChild, HostBinding, Input} from "@angular/core";
import {FUIAttributedListEntryAttributesComponent} from "./attributed-list-entry-attributes/attributed-list-entry-attributes.component";

@Component({
    selector: "fui-attributed-list-entry",
    styleUrls: ["./attributed-list-entry.component.scss"],
    templateUrl: "./attributed-list-entry.component.html"
})
export class FUIAttributedListEntryComponent {
    @ContentChild(FUIAttributedListEntryAttributesComponent) public attributes: FUIAttributedListEntryAttributesComponent;
    @Input() @HostBinding("class.link") public link: boolean;
    @Input() public title: string;
    @Input() public value: string;

    constructor() {
    }
}
